export function TermsVersion1() {
  return (
    <>
      <p>(English Version) Track Account Terms of Service</p>
    </>
  );
}
